import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a83bd3b0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&id=a83bd3b0&lang=scss&scoped=true&"
import style2 from "./index.vue?vue&type=style&index=2&id=a83bd3b0&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83bd3b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\2000HuiTian\\huitianadmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a83bd3b0')) {
      api.createRecord('a83bd3b0', component.options)
    } else {
      api.reload('a83bd3b0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a83bd3b0&scoped=true&", function () {
      api.rerender('a83bd3b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index.vue"
export default component.exports